import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  resetDialog: {
    minWidth: '416px',
    maxWidth: '500px',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(4),

    [theme.breakpoints.down('tablet')]: {
      minWidth: 'auto',
    },

    [theme.breakpoints.down('mobile')]: {
      minWidth: '90%',
    },
  },

  title: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },

  content: {
    padding: theme.spacing(4, 0, 2, 0),
  },

  actions: {
    padding: 0,
    justifyContent: 'start',
  },
}));
